export default "__VITE_ASSET__D9J0En2U__"